export default __webpack_public_path__ + "static/media/icons8-back_to.406b9519.svg";